import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { authApiClient } from '../api/apiClient';
import LoadingSpinner from '../opencomponents/LoadingSpinner';
import PageShell from '../components/PageShell';
import { CornerCard, PrimaryLink, GhostLink } from '../components/ui';
import { color, font } from '../theme/tokens';

const Panel = styled(CornerCard)`
    max-width: 560px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    text-align: center;
`;

const Message = styled.h2`
    margin: 0;
    font-family: ${font.display};
    font-weight: 600;
    font-size: 22px;
    line-height: 1.7;
    letter-spacing: 0.12em;
    color: ${({ $error }) => ($error ? color.bloodHi : color.text)};
`;

function ActivationPage() {
    const { token } = useParams();
    const [status, setStatus] = useState('activating');
    const [message, setMessage] = useState('正在激活您的账户...');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('无效的激活链接。');
            return;
        }

        const activateAccount = async () => {
            try {
                const response = await authApiClient.post(`/auth/activate/${token}`);
                setStatus('success');
                setMessage(response.data.message);
            } catch (err) {
                setStatus('error');
                const errorMessage = err.response?.data?.message || '激活失败，链接可能已过期或无效。';
                setMessage(errorMessage);
            }
        };

        activateAccount();
    }, [token]);

    return (
        <PageShell title="起動" en="ACTIVATION">
            {status === 'activating' && <LoadingSpinner />}
            <Panel pad="56px 40px">
                <Message $error={status === 'error'} role={status === 'error' ? 'alert' : undefined}>{message}</Message>
                {status === 'success' && <PrimaryLink to="/login">前往登录</PrimaryLink>}
                {status === 'error' && <GhostLink to="/register">重新注册</GhostLink>}
            </Panel>
        </PageShell>
    );
}

export default ActivationPage;
